import { render, staticRenderFns } from "./ChatModalRecordVideo.vue?vue&type=template&id=62d49a7b&"
import script from "./ChatModalRecordVideo.vue?vue&type=script&lang=js&"
export * from "./ChatModalRecordVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports